{
    "ConfigureAgents_Add_Title": "Add New Agent",
    "ConfigureAgents_Modify_Title": "Modify Agent",

    "ConfigureAgents_PromptMessage": "Are you sure you want to close this window? All modified configurations will be lost when closed.",
    "ConfigureAgents_PromptConfirm": "Yes",
    "ConfigureAgents_PromptCancel": "Cancel",

    "ConfigureAgents_Tabs_Details": "Agent Details",
    "ConfigureAgents_Tabs_Advanced": "Advanced",
    "ConfigureAgents_Tabs_Omnichannel": "Omnichannel",

    "ConfigureAgents_Footer_Help": "Help?",
    "ConfigureAgents_Footer_Submit": "Save",
    "ConfigureAgents_Footer_Cancel": "Cancel",

    "NAME": "ConfigureAgents"
}